import { render, staticRenderFns } from "./CreateLevelView.vue?vue&type=template&id=6e055b48&"
import script from "./CreateLevelView.vue?vue&type=script&lang=ts&"
export * from "./CreateLevelView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports